var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sent"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M9.5 16L14 11L11 11L11 3L8 3L8 11L5 11L9.5 16Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSent);
export default __webpack_public_path__ + "static/media/icon_sent.b8bb26cd4ff1b1667a190001856f4ac6.svg";
export { ForwardRef as ReactComponent };